module.exports = __webpack_public_path__ + "img/6.74862e0c.jpg";